import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

import { focusRing } from '../styles/focus-ring';

export const tabsListVariants = cva(
  'inline-flex items-center justify-center text-text-secondary',
  {
    variants: {
      variant: {
        pill: 'h-10 rounded-lg bg-background-tertiary p-1',
        line: 'group/tabs-list h-8 gap-1 rounded-none bg-transparent p-0',
      },
    },
    defaultVariants: {
      variant: 'pill',
    },
  }
);

export const tabsTriggerClasses = cn(
  // Shared by both variants
  'inline-flex items-center justify-center whitespace-nowrap text-sm font-normal disabled:pointer-events-none disabled:opacity-50',
  // Pill variant styles
  'rounded-md px-3 py-1.5 transition-all data-[state=active]:bg-surface data-[state=active]:text-text-primary data-[state=active]:shadow-sm',
  focusRing,
  // Line variant overrides
  'group-data-[variant=line]/tabs-list:relative group-data-[variant=line]/tabs-list:rounded-md group-data-[variant=line]/tabs-list:border-2 group-data-[variant=line]/tabs-list:border-transparent group-data-[variant=line]/tabs-list:px-2 group-data-[variant=line]/tabs-list:py-1.5',
  'group-data-[variant=line]/tabs-list:transition-colors',
  'group-data-[variant=line]/tabs-list:gap-1.5 group-data-[variant=line]/tabs-list:[&_svg:not([class*=size-])]:size-4 group-data-[variant=line]/tabs-list:[&_svg]:pointer-events-none group-data-[variant=line]/tabs-list:[&_svg]:shrink-0',
  'group-data-[variant=line]/tabs-list:hover:text-text-primary',
  'group-data-[variant=line]/tabs-list:data-[state=active]:bg-transparent group-data-[variant=line]/tabs-list:data-[state=active]:shadow-none',
  // Line variant underline (after pseudo-element) - only visible for line variant
  'group-data-[variant=line]/tabs-list:after:absolute group-data-[variant=line]/tabs-list:after:inset-x-0 group-data-[variant=line]/tabs-list:after:bottom-0 group-data-[variant=line]/tabs-list:after:h-0.5 group-data-[variant=line]/tabs-list:after:bg-text-primary group-data-[variant=line]/tabs-list:after:opacity-0 group-data-[variant=line]/tabs-list:after:transition-opacity',
  'group-data-[variant=line]/tabs-list:data-[state=active]:after:opacity-100'
);

// TabsContent
export const tabsContentClasses = cn(
  'mt-2',
  // Radix leaves the inactive panel mounted under `hidden`, which a consumer `flex` outranks,
  // so the empty panel pushes the active one down; attribute + class out-specifies it. Also
  // hides `forceMount` panels, so an exit animation there needs an opt-out.
  'data-[state=inactive]:hidden',
  focusRing
);
